const SET_DOMAIN_SUGGESTIONS = 'SET_DOMAIN_SUGGESTIONS';
const TURN_OFF_DOMAIN_SUGGESTIONS = 'TURN_OFF_DOMAIN_SUGGESTIONS';
const TURN_ON_DOMAIN_SUGGESTIONS = 'TURN_ON_DOMAIN_SUGGESTIONS';

export {
  SET_DOMAIN_SUGGESTIONS,
  TURN_OFF_DOMAIN_SUGGESTIONS,
  TURN_ON_DOMAIN_SUGGESTIONS,
};
